import React from "react";
import CardResumenSimulador from "components/Custom/CardResumenSimulador";
import CardTableUltimosResultados from "components/Custom/CardTableUltimosResultados";

// components

export default function ResumenSimulador({ examDashboard }) {
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 rounded-lg">
        <div>
          <CardResumenSimulador promedio={examDashboard.promedio} mejorResultado={examDashboard.mejor_resultado} simuladoresCompletados={examDashboard.simuladores_completados} />
        </div>
        <div className="mt-4">
          <CardTableUltimosResultados ultimosResultados={examDashboard.ultimos_examenes} />
        </div>
      </div>
    </>
  );
}
